import { api } from '../../lib/api';

export interface PayrollPeriodDTO {
  id: number;
  label: string;
  startDate: string;
  endDate: string;
  closedAt: string | null;
  totalNet: string;
  _count?: { items: number };
}

export interface PayrollItemDTO {
  id: number;
  payrollPeriodId: number;
  userId: number;
  baseSalary: string;
  bonuses: string;
  deductions: string;
  net: string;
  user: { id: number; fullName: string; email: string };
}

export interface PayrollPeriodDetailDTO extends PayrollPeriodDTO {
  items: PayrollItemDTO[];
}

export async function listPayrollPeriods(): Promise<PayrollPeriodDTO[]> {
  const { data } = await api.get<PayrollPeriodDTO[]>('/api/payroll/periods');
  return data;
}

export async function getPayrollPeriod(id: number): Promise<PayrollPeriodDetailDTO> {
  const { data } = await api.get<PayrollPeriodDetailDTO>(`/api/payroll/periods/${id}`);
  return data;
}

export async function createPayrollPeriod(body: { label: string; startDate: string; endDate: string }): Promise<PayrollPeriodDTO> {
  const { data } = await api.post<PayrollPeriodDTO>('/api/payroll/periods', body);
  return data;
}

export async function addPayrollItem(periodId: number, body: { userId: number; baseSalary: number; bonuses: number; deductions: number }): Promise<PayrollItemDTO> {
  const { data } = await api.post<PayrollItemDTO>(`/api/payroll/periods/${periodId}/items`, body);
  return data;
}

export async function deletePayrollItem(periodId: number, itemId: number): Promise<void> {
  await api.delete(`/api/payroll/periods/${periodId}/items/${itemId}`);
}

export async function closePayrollPeriod(id: number): Promise<PayrollPeriodDTO> {
  const { data } = await api.post<PayrollPeriodDTO>(`/api/payroll/periods/${id}/close`);
  return data;
}

// Support docs
export interface SupportDocDTO {
  id: number;
  number: string;
  supplierName: string;
  supplierNit: string;
  total: string;
  cufe: string | null;
  issuedAt: string;
}

export async function listSupportDocs(): Promise<SupportDocDTO[]> {
  const { data } = await api.get<SupportDocDTO[]>('/api/support-documents');
  return data;
}

export async function createSupportDoc(body: {
  number: string;
  supplierName: string;
  supplierNit: string;
  total: number;
  issuedAt: string;
}): Promise<SupportDocDTO> {
  const { data } = await api.post<SupportDocDTO>('/api/support-documents', body);
  return data;
}

export async function issueSupportDoc(id: number): Promise<SupportDocDTO> {
  const { data } = await api.post<SupportDocDTO>(`/api/support-documents/${id}/issue`);
  return data;
}
